import main from "../../images/main-pic.png";
import circle from "../../images/circle-shape.png";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

const Features = () => {
  const { t } = useTranslation();
  return (
    <>
      <div id="features" className="features-area-two bg-f7fafd ptb-100">
        <div className="container">
          <div className="saas-section-title">
            <h2>{t("static.features.title")}</h2>
            <div className="bar"></div>
            <p>{t("static.features.description")}</p>
          </div>

          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <div className="features-content">
                <div className="row">
                  <div
                    className="col-lg-6 col-md-6"
                    data-aos="fade-up"
                    data-aos-duration="800"
                    data-aos-once="true"
                    data-aos-delay="100"
                  >
                    <div className="box">
                      <i className="far fa-hand-point-up"></i>
                      {t("static.features.feature1")}
                    </div>
                  </div>
                  <div
                    className="col-lg-6 col-md-6"
                    data-aos="fade-up"
                    data-aos-duration="800"
                    data-aos-once="true"
                    data-aos-delay="200"
                  >
                    <div className="box">
                      <i className="far fa-image"></i>
                      {t("static.features.feature2")}
                    </div>
                  </div>

                  <div
                    className="col-lg-6 col-md-6"
                    data-aos="fade-up"
                    data-aos-duration="800"
                    data-aos-once="true"
                    data-aos-delay="300"
                  >
                    <div className="box">
                      <i className="fas fa-fighter-jet"></i>
                      {t("static.features.feature3")}
                    </div>
                  </div>
                  <div
                    className="col-lg-6 col-md-6"
                    data-aos="fade-up"
                    data-aos-duration="800"
                    data-aos-once="true"
                    data-aos-delay="400"
                  >
                    <div className="box">
                      <i className="fas fa-lock"></i>
                      {t("static.features.feature4")}
                    </div>
                  </div>
                  <div
                    className="col-lg-6 col-md-6"
                    data-aos="fade-up"
                    data-aos-duration="800"
                    data-aos-once="true"
                    data-aos-delay="200"
                  >
                    <div className="box">
                      <i className="far fa-file"></i>
                      {t("static.features.feature5")}
                    </div>
                  </div>

                  <div
                    className="col-lg-6 col-md-6"
                    data-aos="fade-up"
                    data-aos-duration="800"
                    data-aos-once="true"
                    data-aos-delay="600"
                  >
                    <div className="box">
                      <i className="fas fa-location-arrow"></i>
                      {t("static.features.feature6")}
                    </div>
                  </div>

                  <div
                    className="col-lg-6 col-md-6"
                    data-aos="fade-up"
                    data-aos-duration="800"
                    data-aos-once="true"
                    data-aos-delay="500"
                  >
                    <div className="box">
                      <i className="fas fa-chart-simple"></i>
                      {t("static.features.feature7")}
                    </div>
                  </div>
                  <div
                    className="col-lg-6 col-md-6"
                    data-aos="fade-up"
                    data-aos-duration="800"
                    data-aos-once="true"
                    data-aos-delay="800"
                  >
                    <div className="box">
                      <i className="fas fa-table"></i>
                      {t("static.features.feature8")}
                    </div>
                  </div>

                  <div
                    className="col-lg-6 col-md-6"
                    data-aos="fade-up"
                    data-aos-duration="800"
                    data-aos-once="true"
                    data-aos-delay="700"
                  >
                    <div className="box">
                      <i className="fas fa-filter"></i>
                      {t("static.features.feature9")}
                    </div>
                  </div>

                  <div
                    className="col-lg-6 col-md-6"
                    data-aos="fade-up"
                    data-aos-duration="800"
                    data-aos-once="true"
                    data-aos-delay="900"
                  >
                    <div className="box">
                      <i className="fas fa-database"></i>
                      {t("static.features.feature10")}
                    </div>
                  </div>

                  <div
                    className="col-lg-6 col-md-6"
                    data-aos="fade-up"
                    data-aos-duration="800"
                    data-aos-once="true"
                    data-aos-delay="1000"
                  >
                    <div className="box">
                      <i className="fas fa-database"></i>
                      {t("static.features.feature11")}
                    </div>
                  </div>
                  <div
                    className="col-lg-6 col-md-6"
                    data-aos="fade-up"
                    data-aos-duration="800"
                    data-aos-once="true"
                    data-aos-delay="1000"
                  >
                    <div className="box">
                      <i className="fas fa-pencil"></i>
                      {t("static.features.feature12")}
                    </div>
                  </div>

                  <div
                    className="col-lg-6 col-md-6"
                    data-aos="fade-up"
                    data-aos-duration="800"
                    data-aos-once="true"
                    data-aos-delay="1000"
                  >
                    <div className="box">
                      <i className="fas fa-gear"></i>
                      {t("static.features.feature13")}
                    </div>
                  </div>
                  <div
                    className="col-lg-6 col-md-6"
                    data-aos="fade-up"
                    data-aos-duration="800"
                    data-aos-once="true"
                    data-aos-delay="1000"
                  >
                    <div className="box">
                      <i className="fas fa-database"></i>
                      {t("static.features.feature14")}
                    </div>
                  </div>
                  <div
                    className="col-lg-6 col-md-6"
                    data-aos="fade-up"
                    data-aos-duration="800"
                    data-aos-once="true"
                    data-aos-delay="1000"
                  >
                    <div className="box">
                      <i className="fas fa-cloud"></i>
                      {t("static.features.feature15")}
                    </div>
                  </div>
                  <div
                    className="col-lg-6 col-md-6"
                    data-aos="fade-up"
                    data-aos-duration="800"
                    data-aos-once="true"
                    data-aos-delay="1000"
                  >
                    <div className="box">
                      <i className="fas fa-bell"></i>
                      {t("static.features.feature16")}
                    </div>
                  </div>
                  <div
                    className="col-lg-6 col-md-6"
                    data-aos="fade-up"
                    data-aos-duration="800"
                    data-aos-once="true"
                    data-aos-delay="1000"
                  >
                    <div className="box">
                      <i className="fas fa-database"></i>
                      {t("static.features.feature17")}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-12">
              <div className="features-image">
                <img
                  src={main}
                  alt="main-pic"
                  width={342}
                  height={396}
                  data-aos="fade-up"
                  data-aos-duration="800"
                  data-aos-once="true"
                  data-aos-delay="1000"
                />
                <img
                  src={circle}
                  className="rotate-image rotateme"
                  alt="circle"
                  width={524}
                  height={518}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Features;
